/**
 * Controller: TemplatesShowDeletedEventsModal
 */
angular.module('acme.view.application.templates.showDeletedEventsModal.controllers', [])
.controller('TemplatesShowDeletedEventsModalController', [ '$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {

    $scope.errors = [];

    $scope.model = [];

    $scope.init = function() {

    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);